<mat-form-field id="autoComplete-mat-form" [formGroup]="group" class="custom-form-field">
  <mat-label id="autoComplete-mat-label">{{ field.displayName }}</mat-label>
  <input
    type="text"
    aria-label="Number"
    matInput
    (keyup)="changeMyControl()"
    [formControlName]="field.name"
    [matAutocomplete]="auto"
    [name]="field.name"
  />
  <mat-autocomplete id="autoComplete-mat-auto" #auto="matAutocomplete">
    <mat-option id="autoComplete-mat-option" *ngFor="let item of filteredOptions" [value]="item.value">
      {{ item.value }}
    </mat-option>
  </mat-autocomplete>
  <ng-container id="autoComplete-ngContain" *ngFor="let validation of field.validations" ngProjectAs="mat-error">
    <mat-error id="autoComplete-mat-error{{ field.name }}" *ngIf="group.get(field.name).hasError(validation.name)">{{
      validation.message
    }}</mat-error>
  </ng-container>
</mat-form-field>
